import React from "react";

export default function StatCard({
  label,
  value,
  helper,
  icon,
  color = "gray",
  description,
}) {
  const colorClasses = {
    blue: {
      gradient: "from-blue-500 to-cyan-500",
      light: "bg-blue-50",
      iconBg: "bg-blue-100",
      icon: "text-blue-600",
      value: "text-blue-700",
    },
    gray: {
      gradient: "bg-[#ad160e]",
      light: "bg-gray-50",
      iconBg: "bg-gray-200",
      icon: "text-gray-700",
      value: "text-gray-800",
    },
    green: {
      gradient: "from-green-500 to-emerald-500",
      light: "bg-green-50",
      iconBg: "bg-green-100",
      icon: "text-green-600",
      value: "text-green-700",
    },
    orange: {
      gradient: "from-orange-500 to-amber-500",
      light: "bg-orange-50",
      iconBg: "bg-orange-100",
      icon: "text-orange-600",
      value: "text-orange-700",
    },
    purple: {
      gradient: "from-purple-500 to-fuchsia-500",
      light: "bg-purple-50",
      iconBg: "bg-purple-100",
      icon: "text-purple-600",
      value: "text-purple-700",
    },
    red: {
      gradient: "from-red-500 to-pink-500",
      light: "bg-red-50",
      iconBg: "bg-red-100",
      icon: "text-red-600",
      value: "text-red-700",
    },
  };

  const colors = colorClasses[color];

  return (
    <div className="group relative overflow-hidden rounded-sm border border-gray-200 bg-white transition-all duration-300">
      {/* Gradient u góry */}
      <div className={`h-1 w-full bg-gradient-to-r ${colors.gradient}`} />

      {/* Delikatne tło */}
      <div
        className={`absolute right-0 top-0 h-28 w-28 rounded-full blur-3xl opacity-20 ${colors.light}`}
      />

      <div className="relative flex h-full flex-col justify-between p-2">
        {/* Header */}
        <div className="flex items-start justify-between">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-gray-500">
              {label}
            </p>

            <h3 className={`mt-1 text-xl font-bold ${colors.value}`}>
              {value}
            </h3>

            {helper && (
              <p className="mt-1 text-sm text-gray-500">
                {helper}
              </p>
            )}
          </div>

          {icon && (
           <div
  className={`
    rounded-sm
    p-3
    ${colors.iconBg}
    ${colors.icon}
    shadow-sm
    transition-transform
    duration-300
    group-hover:scale-110
    group-hover:rotate-6
  `}
>
  {React.cloneElement(icon, {
    className: "w-4 h-4 sm:w-6 sm:h-6 md:w-6 md:h-6"
  })}
</div>
          )}
        </div>

        {/* Footer */}
        {description && (
          <div className="mt-2 border-t border-gray-100 pt-3">
            <p className="text-xs leading-relaxed text-gray-500">
              {description}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}